import Tippy from '@tippyjs/react/headless';
import classnames from 'classnames';
import React from 'react';
import { BLOCKING_TIME } from "../../helper/hooks/useResizeObserver.js";
import styles from "./DropdownContainer.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
const autoWidth = {
  name: 'autoWidth',
  fn: ({
    reference,
    popper
  }) => {
    let lastSuccessEventCall = 0;
    const observer = new ResizeObserver(entries => {
      window.requestAnimationFrame(() => {
        if (!entries || entries.length === 0) {
          return;
        }
        const currentTime = Date.now();
        const blockTime = lastSuccessEventCall + BLOCKING_TIME;

        // buffer call for 33.3ms
        if (blockTime > currentTime) {
          return;
        }
        lastSuccessEventCall = currentTime;
        for (const entry of entries) {
          const {
            width
          } = entry.contentRect;
          popper.style.width = `${width}px`;
        }
      });
    });
    return {
      onShow() {
        const {
          width
        } = reference.getBoundingClientRect();
        popper.style.width = `${width}px`;
        observer.observe(reference);
      },
      onHide() {
        observer.unobserve(reference);
      }
    };
  }
};
const hideOnEsc = {
  name: 'hideOnEsc',
  defaultValue: true,
  fn({
    hide
  }) {
    function onKeyDown(event) {
      if (event.keyCode === 27) {
        hide();
        const {
          target
        } = event;
        if (target instanceof HTMLElement) {
          target.blur();
        }
      }
    }
    return {
      onShow() {
        document.addEventListener('keydown', onKeyDown);
      },
      onHide() {
        document.removeEventListener('keydown', onKeyDown);
      }
    };
  }
};
export function DropdownContainer({
  visible,
  reference,
  children,
  onClickOutside,
  name,
  appendTo,
  className,
  hasAutoWidth = true,
  placement = 'bottom-start',
  offset = [0, 4]
}) {
  return /*#__PURE__*/_jsx(Tippy, {
    plugins: [...(hasAutoWidth ? [autoWidth] : []), hideOnEsc],
    interactive: true,
    onClickOutside: onClickOutside,
    offset: offset,
    reference: reference,
    appendTo: appendTo || document.querySelector('#root') || 'parent',
    render: args => /*#__PURE__*/_jsx("div", {
      className: classnames(styles.dropdownContainer, className),
      ...args,
      "data-testid": name ? `dropdown-container-${name}` : undefined,
      children: children
    }),
    visible: visible,
    placement: placement
  });
}